export default __webpack_public_path__ + "static/media/Iscreen_placeholder.8d0890ff.png";